import { useCallback, useEffect } from "react"
import { followApi } from "../followSlice"
import { useAppDispatch } from "../hooks"
import type { EventRouter } from "../../components/messaging/types"
import type { IFollowing } from "../../types/follow"

type FollowEventProps = {
    followingEvent: EventRouter<IFollowing> | undefined
}

/**
 * Hook to listen for global follow/unfollow events and update the
 * corresponding RTK Query cache entry for the affected user's follow status.
 */
export const useFollowEventEffect = ({
    followingEvent,
}: FollowEventProps): void => {
    const dispatch = useAppDispatch()

    const handleFollowingUpdate = useCallback(
        (payload: IFollowing) => {
            dispatch(
                followApi.util.updateQueryData(
                    "isFollowing",
                    payload.roomName,
                    (draft) => {
                        draft.following = payload.following
                    },
                ),
            )
        },
        [dispatch],
    )

    useEffect(() => {
        if (!followingEvent) return

        followingEvent.listen(handleFollowingUpdate)

        return () => {
            followingEvent.removeListener(handleFollowingUpdate)
        }
    }, [followingEvent, handleFollowingUpdate])
}
